var render = function render(){var _vm=this,_c=_vm._self._c;return _c('examples-block',{attrs:{"gitUrl":"src/components/examples/Table/TableSetWidthColumn.vue","title":"Таблица с фиксированной шириной колонок"}},[_c('r-table',{attrs:{"headers":_vm.headers,"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }